var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDepositFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 11v10a1 1 0 01-1 1H7a1 1 0 01-1-1V11H3a1 1 0 01-1-1V3a1 1 0 011-1h18a1 1 0 011 1v7a1 1 0 01-1 1h-3zM3.5 3.5v6H6v-2H5A.75.75 0 015 6h14a.75.75 0 010 1.5h-1v2h2.5v-6h-17zm10.47 12.53L12 14.06l-1.97 1.97a.75.75 0 11-1.06-1.06l2.323-2.324a1 1 0 011.414 0l2.323 2.324a.75.75 0 11-1.06 1.06z",
    fill: "currentColor"
  })));
}
SvgDepositFilled.displayName = 'DepositFilled';
export default SvgDepositFilled;